import CTNMessage from '@ctn/ui/components/ctn-message';

import { useGlobalContext } from '@/context/global.context';

import ResumenStep1 from './EnvioSection/step1';
import ResumenStep2 from './EnvioSection/step2';
import ResumenStep3 from './EnvioSection/step3';

const ConfirmacionEnvioSection = () => {
	const {
		maestrosTramite: { configuracionTramite },
	} = useGlobalContext();

	return (
		<div className="p-pnp-confirm">
			{!configuracionTramite?.permitePreseleccionNotario && <CTNMessage
				content={
					<p>
						La asignación del notario no se va a realizar en este momento. Una vez dada de alta la solicitud, los intervinientes deberán elegir el notario que deseen para la gestión de la misma. Se deberán poner en contacto con el notario elegido o personarse a la notaría para proceder a la asignación y gestión de la solicitud
					</p>
				}
				className="u-mt-24"
				icon="info"
				status="info"
				mode="outline"
				closable={false}
			/>}
			<ResumenStep1 />
			<ResumenStep2 />
			<ResumenStep3 />
		</div>
	);
};

export default ConfirmacionEnvioSection;
